export enum CrudType {
  Post = "post",
  Put = "put",
  Delete = "delete",
  Get = "get",
}
